import React, { useState, useEffect } from 'react';
import {
  MDBNavbar,
  MDBNavbarToggler,
  MDBContainer,
  MDBNavbarBrand,
  MDBCollapse,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBIcon,
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBCarouselElement,
  MDBCarouselCaption,
  MDBBtn,
  MDBFooter,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBTypography,
  MDBAnimation
} from 'mdb-react-ui-kit';
import './AppJaven.css';

const JDesk = () => {
  const [showNav, setShowNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <header>
        <MDBNavbar
          expand="lg"
          fixed="top"
          dark
          className={`navbar-scroll ${scrolled ? 'navbar-scrolled' : ''}`}
        >
          <MDBContainer>
            <MDBNavbarBrand href="#" className="ms-auto mb-2 mb-lg-0">
              <img
                src="https://opengrit.com/images/javen"
                height="40"
                alt="logo"
              />
            </MDBNavbarBrand>
            <MDBNavbarToggler
              type="button"
              data-target="#navbarExample01"
              aria-controls="navbarExample01"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => setShowNav(!showNav)}
            >
              <MDBIcon icon="bars" fas />
            </MDBNavbarToggler>
            <MDBCollapse show={showNav} navbar>
              <MDBNavbarNav className="ms-auto mb-2 mb-lg-0">
                <MDBNavbarItem>
                  <MDBNavbarLink href="#news">Home</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#employees">Employees</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#adoptions">Services</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#foundation">Clients</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#help" style={{ whiteSpace: 'nowrap' }}>How can I help?</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#education">Careers</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#about" style={{ whiteSpace: 'nowrap' }}>About us</MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="/contact">Contact</MDBNavbarLink>
                </MDBNavbarItem>
              </MDBNavbarNav>
              <MDBNavbarNav className="flex-row">
                <MDBNavbarItem>
                  <MDBNavbarLink href="#!">
                    <MDBIcon fab icon="facebook-square" />
                  </MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#!">
                    <MDBIcon fab icon="instagram" />
                  </MDBNavbarLink>
                </MDBNavbarItem>
                <MDBNavbarItem>
                  <MDBNavbarLink href="#!">
                    <MDBIcon fab icon="youtube" />
                  </MDBNavbarLink>
                </MDBNavbarItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
        <section>
      <div
        id="intro"
        className="bg-image"
        style={{
          backgroundImage: "url('https://opengrit.com/images/headerImg')",
          height: '100vh',
        }}
      >
        <div className="mask">
          <MDBContainer className="d-flex justify-content-center align-items-center h-100">
            <MDBRow className="align-items-center">
              <MDBCol md="6" className="my-5">
                <MDBTypography tag='h1'   className="mb-5" style={{ color: '#112f6b' }}>
                Consistently delivering excellence in all we do, every time
                </MDBTypography>
                <p className="lead mb-5">
                We ensure top-tier performance in every project, delivering consistent excellence in IT solutions.Our commitment to excellence drives us to exceed expectations in every engagement, every time.Partner with us for unwavering quality in IT consulting, where exceptional service is our standard.

</p>
<MDBBtn color="light" rounded size="lg" className="me-1">   
                  Services
                </MDBBtn>
                <MDBBtn color="danger" rounded size="lg" className="ms-1">
                  Learn more
                </MDBBtn>
              </MDBCol>
              <MDBCol md="6">
                <img
                  src="https://mdbootstrap.com/img/Mockups/Transparent/Small/admin-new.png"
                  alt=""
                  className="img-fluid"
                />
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </div>
      </div>
    </section>
        {/* <MDBCarousel id="introCarousel" showControls showIndicators fade>
         
            <MDBCarouselItem itemId="1" className="active">
           
              <div className="mask">
                <div className="d-flex align-items-end h-100">
                  <MDBContainer className="d-flex justify-content-center justify-content-lg-start mb-4 pb-2">
                  <h1 className='text-black'>First slide label</h1>
                  <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                    <MDBBtn color="primary" size="lg" className="ms-lg-5">
                      Seniors for adoption
                    </MDBBtn>
                  </MDBContainer>
                </div>
              </div>
            </MDBCarouselItem>
            <MDBCarouselItem itemId="2">
           
              <div className="mask">
                <div className="d-flex align-items-end h-100">
                  <MDBContainer className="d-flex justify-content-center justify-content-lg-end mb-4 pb-2">
                    <MDBBtn color="primary" size="lg" className="me-lg-5">
                      Cats for adoption
                    </MDBBtn>
                  </MDBContainer>
                </div>
              </div>
            </MDBCarouselItem>
            <MDBCarouselItem itemId="3">
              <div className="mask">
                <div className="d-flex align-items-end h-100">
                  <MDBContainer className="d-flex justify-content-center justify-content-lg-end mb-4 pb-2">
                    <MDBBtn color="primary" size="lg" className="me-lg-5">
                      Dogs for adoption
                    </MDBBtn>
                  </MDBContainer>
                </div>
              </div>
            </MDBCarouselItem>
         
        </MDBCarousel> */}
      </header>

    
          <MDBContainer className="my-5">
          <section>
            <div className="text-center">
              <MDBIcon icon="pen-nib" size="2x" className="text-primary" />
              <h2 className="my-4">Our services are open from 12-17</h2>
            </div>

            <MDBRow className="d-flex justify-content-center">
              <MDBCol md="10" className="mb-5">
                <p className="mb-4">
                The best teams do not just have the best players they have the players who play the best together! At Javen, we can provide the ultimate support for your IT team, giving you the right people for the job. The Right Person in the Right Place at the Right Time has always been a success story.
Many companies and IT departments find it challenging to respond to constantly changing technology needs and initiatives using only internal staff. To acquire strategic skills in a timely and cost-effective manner, many CIOs and technical managers turn to Javen for quality solutions. Javen offers companies the ability to respond quickly to technology initiatives by strategically acquiring skills and cost-effectively managing available resources.

Javen gives you the ability to deliver IT resources to your organization quickly and efficiently by giving you the brainpower of highly trained IT consultants and specialists. Reliable, innovative IT professionals from Javen can help you take your company to the next level yet give you the flexibility to take on your greatest challenges without the expense, delay, or inconvenience of lengthy recruiting and assessment processes.
                </p>

                <div className="text-end">
                  <MDBBtn color="secondary" rounded>
                    <MDBIcon fas icon="book-reader" className="pe-2" />
                    Learn more
                  </MDBBtn>
                </div>
              </MDBCol>
            </MDBRow>
          </section>

          <MDBContainer>
            <div className="text-center">
              <MDBIcon icon="pen-nib" size="2x" className="text-primary" />
              <h2 className="my-4 pb-2">Recently found jobs</h2>
            </div>

            <MDBRow>
              <MDBCol md="6">
                <MDBCarousel showControls showIndicators fade>
              
                    <MDBCarouselItem itemId="1"   className='w-100 d-block h-50 text-center'>
                      <img
                        src="https://opengrit.com/images/target"  height={500}
                        alt="..."
                      />
                      <MDBCarouselCaption className="d-none d-md-block bg-dark bg-opacity-50">
                        <h5>0032/21</h5>
                        <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
                      </MDBCarouselCaption>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="2"   className='w-100 d-block'>
                      <img
                        src="https://opengrit.com/images/bestbuy" height={250}
                        alt="..."
                      />
                      
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="3"   className='w-100 d-block'>
                      <img
                        src="https://opengrit.com/images/cargil" height={250}
                        alt="..."
                      />
                    
                    </MDBCarouselItem>
                  
                </MDBCarousel>
              </MDBCol>

              <MDBCol md="6">
                <h6>24/7 contact for this jos</h6>
                <p className="mb-4 pb-2">+12 345 567 789, +12 456 835 097, info@javen.com</p>
                <p className="mb-2">New York, NY 10012, US</p>
                <p className="mb-4 pb-2">Access from 123 Street by bus number 124</p>
                <h6>available for talk</h6>
                <p className="mb-4 pb-2">7 days a week, from 10:00 - 18:00</p>
                <p className="mb-4 pb-2 text-danger font-weight-bold">
                  explain about it 
                </p>
                <ul className="mb-4 pb-2">
                  <li><a href="#!" className="link-secondary">FullTime</a></li>
                  <li><a href="#!" className="link-secondary">No relocation expenses</a></li>
                </ul>
                <MDBBtn outline color="dark" size="lg" rounded>
                  See other Jobs
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
      </MDBContainer>

        <MDBContainer style={{ backgroundColor: '#f2f2f2' }}>
          <MDBContainer className="py-5">
           
            <MDBRow>
              <MDBCol md="3" className="mb-4">
                <div className="bg-image hover-zoom"> 
                  <img 
                    src="https://mdbootstrap.com/img/Photos/new-templates/animal-shelter/img4.jpg" height={300}
                    alt="Offer"
                       className="img-fluid object-cover w-100"
                  />
                  <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
        <div className='d-flex justify-content-center align-items-center h-100'>
          <p className='text-white mb-0'>Clients</p>
        </div>
      </div>
                  <a href="#!">
                    <div className="mask"></div>
                  </a>
                </div>
                <div className="text-center">
                  <h5 className="mb-4">Integrative.</h5>
                  <MDBBtn color="primary" rounded>
                    Learn more
                  </MDBBtn>
                </div>
              </MDBCol>

              <MDBCol md="3" className="mb-4">
                <div className="bg-image hover-zoom mb-4">
                  <img
                    src="https://opengrit.com/images/aboutUs" height={300}
                    alt="Offer"
                   
                  />
                  <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
        <div className='d-flex justify-content-center align-items-center h-100'>
          <p className='text-white mb-0 mt-5'>Promised</p>
        </div>
      </div>
                  <a href="#!">
                    <div className="mask"></div>
                  </a>
                </div>
                <div className="text-center">
                  <h5 className="mb-4"> Minneapolis based</h5>
                  <MDBBtn color="primary" rounded>
                    Learn more
                  </MDBBtn>
                </div>
              </MDBCol>

              <MDBCol md="3" className="mb-4">
                <div className="bg-image hover-zoom mb-4">
                  <img
                    src="https://opengrit.com/images/employees" height={300}
                    alt="Offer"
                   
                  />
                  <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
        <div className='d-flex justify-content-center align-items-center h-100'>
          <p className='text-white mb-0'>Employees</p>
        </div>
      </div>
                  <a href="#!">
                    <div className="mask"></div>
                  </a>
                </div>
                <div className="text-center">
                  <h5 className="mb-4">Visionary LeaderShip</h5>
                  <MDBBtn color="primary" rounded>
                    Learn more
                  </MDBBtn>
                </div>
              </MDBCol>
              <MDBCol md="3" className="mb-4">
                <div className="bg-image hover-zoom mb-4 bg-dark">
                  <img className='bg-dark'
                    src="https://opengrit.com/images/javenGrowth" height={300}
                    alt="Offer"
                   
                  />
                  <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}>
        <div className='d-flex justify-content-center align-items-center h-100'>
          <p className='text-white mb-0'>News</p>
          <MDBAnimation
        infinite
        tag='i'
        animation='zoom-in'
        start='onLoad'
        duration={2000}
      >
       <h3 className='text-white'> Fastest Growing</h3>
</MDBAnimation>
        </div>
      </div>
                  <a href="#!">
                    <div className="mask"></div>
                  </a>
                </div>
                <div className="text-center">
                  <h5 className="mb-4">Fastest growing</h5>
                  <MDBBtn color="primary" rounded>
                    Learn more
                  </MDBBtn>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </MDBContainer>
      

      <MDBFooter bgColor="primary" className="text-white text-center text-lg-start">
        <MDBContainer className="p-4">
          <MDBRow className="my-4 mx-5">
            <MDBCol lg="3" md="6" className="mb-4 mb-md-0">
              <div
                className="rounded-circle bg-white shadow-1-strong d-flex align-items-center justify-content-center mb-4 mx-auto"
                style={{ width: '150px', height: '150px' }}
              >
                <img
                  src="https://opengrit.com/images/javen"
                  height="30"
                  alt=""
                  loading="lazy"
                />
              </div>
              <p className="text-center">
                Innovative Approach
              </p>
              <ul className="list-unstyled d-flex flex-row justify-content-center">
                <li>
                  <a className="text-white px-2" href="#!">
                    <MDBIcon fab icon="facebook-square" />
                  </a>
                </li>
                <li>
                  <a className="text-white px-2" href="#!">
                    <MDBIcon fab icon="instagram" />
                  </a>
                </li>
                <li>
                  <a className="text-white ps-2" href="#!">
                    <MDBIcon fab icon="youtube" />
                  </a>
                </li>
              </ul>
            </MDBCol>

            <MDBCol lg="3" md="6" className="mb-4 mb-md-0">
              <h5 className="text-uppercase mb-4">Clients</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#!" className="text-white">
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    Manufacturing
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-white">
                    <MDBIcon icon="pen-nib" className="pe-3" />
                   IT
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-white">
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    Hospitality
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-white">
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    Retail
                  </a>
                </li>
              </ul>
            </MDBCol>

            <MDBCol lg="3" md="6" className="mb-4 mb-md-0">
              <h5 className="text-uppercase mb-4">About</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#!" className="text-white" style={{ whiteSpace: 'nowrap' }}>
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    General information
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-white">
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    About the Company
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-white" style={{ whiteSpace: 'nowrap' }}> 
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    Statistic data
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#!" className="text-white">
                    <MDBIcon icon="pen-nib" className="pe-3" />
                    Job
                  </a>
                </li>
              </ul>
            </MDBCol>

            <MDBCol lg="3" md="6" className="mb-4 mb-md-0">
              <h5 className="text-uppercase mb-4">Contact</h5>
              <ul className="list-unstyled">
                <li>
                  <p>
                    <MDBIcon icon="map-marker-alt" className="pe-2" style={{ whiteSpace: 'nowrap' }}/>
                    Plymouth, 57 Street, MN
                  </p>
                </li>
                <li>
                  <p>
                    <MDBIcon icon="phone" className="pe-2" />
                    + 01 612 567 89
                  </p>
                </li>
                <li>
                  <p>
                    <MDBIcon icon="envelope" className="pe-2" />
                    contact@javen.com
                  </p>
                </li>
              </ul>
            </MDBCol>
          </MDBRow>
        </MDBContainer>

        <div className="text-center p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
          © 2020 Copyright:
          <a className="text-white" href="https://javen.com/">
            javen.com
          </a>
        </div>
      </MDBFooter>
    </>
  );
};

export default JDesk;
